export default "__VITE_ASSET__CJeqCbSU__"